import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { StyledSubOptionsContainer } from '../PdfExportConfigDialog.styles';
import { FundPdfOptions } from '../PdfExportConfigDialog.types';
import { FundSubOptionsProps } from './SubOptions.types';

export const FundSubOptions = ({ options, onOptionsChange, showCondition }: FundSubOptionsProps) => {
  if (!showCondition) {
    return null;
  }

  const handleOptionChange = (optionKey: keyof FundPdfOptions) => {
    onOptionsChange({
      ...options,
      [optionKey]: !options[optionKey],
    });
  };

  return (
    <StyledSubOptionsContainer>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={options.summary}
              onChange={() => handleOptionChange('summary')}
            />
          }
          label="Summary"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={options.scheduleOfInvestments}
              onChange={() => handleOptionChange('scheduleOfInvestments')}
            />
          }
          label="Schedule of Investments"
        />
      </FormGroup>
    </StyledSubOptionsContainer>
  );
};
